<header class="page-header">
  @if (parentUrl()) {
    <button mat-icon-button (click)="breadcrumbService.back()" matTooltip="Volver">
      <mat-icon>arrow_back</mat-icon>
    </button>
  }

  @if (icon) {
    <mat-icon class="page-header__icon">{{ icon }}</mat-icon>
  }

  <div class="page-header__text">
    @if (title) {
      <h2 class="page-header__title">{{ title }}</h2>
    }
    @if (subtitle) {
      <p class="page-header__subtitle">{{ subtitle }}</p>
    }
  </div>

  <span class="page-header__spacer"></span>
  <ng-content select="[page-header-actions]"></ng-content>
</header>
